import React from "react";
import { Divider, Tab } from "semantic-ui-react";
import { StampAssignmentDestroyContainer } from "./destroy.container";
import { StampAssignmentUndoDestroyContainer } from "./undo-destroy.container";

export const StampRollManualAssignmentContainer = () => {
    const panes = [
        {
            menuItem: "Destroy",
            // eslint-disable-next-line react/display-name
            render: () => (
                <Tab.Pane attached={false}>
                    <StampAssignmentDestroyContainer />
                </Tab.Pane>
            ),
        },
        {
            menuItem: "Undo Destroyed Stamps",
            // eslint-disable-next-line react/display-name
            render: () => (
                <Tab.Pane attached={false}>
                    <StampAssignmentUndoDestroyContainer />
                </Tab.Pane>
            ),
        },
    ];
    return (
        <>
            <Divider hidden />
            <Tab
                data-cy="stamp_roll_manual_assignment_tab"
                menu={{ pointing: true }}
                panes={panes}
            />
        </>
    );
};
